import { gql } from '@apollo/client'

export const PURCHASE_FRAGMENT = gql`
  fragment PurchaseFragment on Purchase {
    id
    amount
    category
    status
    identificationToken
    reductionAmount
    productId
    recurrent
    commitmentPercent
    legalFees
  }
`
